
import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const PopupClose: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22.275" height="21.105" viewBox="0 0 22.275 21.105">
            <g transform="translate(1.767 1.768)">
                <line x2="18.741" y2="17.57" transform="translate(0 0)" fill="none" stroke="#253746" strokeLinecap="round" strokeWidth="2.5" />
                <line x1="17.57" y2="17.57" transform="translate(0.586 0)" fill="none" stroke="#253746" strokeLinecap="round" strokeWidth="2.5" />
            </g>
        </svg>
    );
};

export default React.memo(PopupClose);